<template>
    <div
        v-show="isShown"
        v-qa="dataQa"
        class="fixed-always-rendered"
    >
        <slot name="default"></slot>
    </div>
</template>

<script lang="ts" setup>
import { toRef } from 'vue'
import { useHideBodyOverflow } from '@/composables/useHideBodyOverflow'
import { useEmitCloseOnEscapeKey } from '@/composables/ui/useEmitCloseOnEscapeKey'

// This component will always render its content but will hide its
// contents based on the `isShown` prop
// This is helpful when you want to render the content of a modal for SEO purposes

const props = defineProps<{
    isShown: boolean
    dataQa?: string
}>()

const isShown = toRef(() => props.isShown)

const emit = defineEmits<{
    close: []
}>()

useHideBodyOverflow({ isHidden: isShown })
useEmitCloseOnEscapeKey(emit, isShown)
</script>

<style lang="scss" scoped>
.fixed-always-rendered {
    @include fixed;

    z-index: 1000;
}
</style>
